import { useTheme } from '@material-ui/core/styles';
// import WhereToVoteIcon from '@material-ui/icons/WhereToVote';
import { BiCheckDouble } from 'react-icons/bi';
import { lighten } from 'polished';

import { Card, ICardsProps } from '../../../../components/Card';
import { useSettings } from '../../../../hooks/settings';

export const OrdersDeliveredCard = (
  props: Pick<ICardsProps, 'content' | 'percentage' | 'loading' | 'onClick'>
) => {
  const theme = useTheme();
  const { cardsLoading } = useSettings();

  return (
    <Card
      title="Entregas"
      icon={<BiCheckDouble />}
      cardColor={lighten(0.325, theme.palette.success.main)}
      loading={cardsLoading}
      {...props}
    />
  );
};
